module.exports = __webpack_public_path__ + "img/patient-card-tabs-desktop-en.71443094.jpg";